export default [
  {
    title: 'لیدها و درخواست‌ها',
    icon: 'bx bx-user-voice',
    route: { name: 'lead' },
    resource: 'LeadManager',
    action: 'show',
  },
]
